/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_3_TitleInputs */

const en_vc_mcp_3_title = /** @type {(inputs: Vc_Mcp_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readable files`)
};

const zh_vc_mcp_3_title = /** @type {(inputs: Vc_Mcp_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看得懂的文件格式`)
};

/**
* | output |
* | --- |
* | "Readable files" |
*
* @param {Vc_Mcp_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_3_title = /** @type {((inputs?: Vc_Mcp_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_3_title(inputs)
	return zh_vc_mcp_3_title(inputs)
});
export { vc_mcp_3_title as "vc.mcp.3.title" }